import script from "./InputForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InputForm.vue?vue&type=script&setup=true&lang=js"

import "./InputForm.vue?vue&type=style&index=0&id=512807e1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-512807e1"]])

export default __exports__